// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.show-mobile[data-v-d07b727a] {\n  display: none;\n}\n@media (max-width: 568px) {\n.show-mobile[data-v-d07b727a] {\n    display: block;\n}\n.hide-mobile[data-v-d07b727a] {\n    display: none;\n}\n}\n", ""]);
// Exports
module.exports = exports;
